import { getSelectEDS, getSelectPromotores, getSelectProductos } from 'app/vistas/Reportes/servicios/serviciosSelect'
import React, { useEffect, useMemo, useState } from 'react'
import Storage from 'util/store/Storage'
import { parseToSelectOption } from 'util/funcionesNews'
import { getBusinessService } from 'services/selectServices/services'
import { getOrganizationsByUser } from 'app/vistas/ClientesCredito/Flotas/services/flotas.services'
import { getMediosPagos, getProgramasLoyalty } from 'app/vistas/Configuracion/GestionMediosPagos/servicios'
import { getSicomStates } from 'app/vistas/GNV/Monitor/services'

interface IProps {
  eds?: boolean,
  business?: boolean,
  typeCredit?: boolean,
  clients?: boolean,
  assignmentType?: boolean,
  organizations?: boolean,
  payMethods?: boolean,
  promotersByEds?: boolean
  stateSicom?: boolean
  fidelization_program?: boolean
  producto?: boolean
}
const  useGenericInfo = (props: IProps) => {
  const { eds, business, organizations, payMethods, stateSicom, fidelization_program, producto } = props
  const { empresasHijos, usuario } = Storage.getState()
  const [edsList, setedsList] = useState<any[]>([])
  const [negociosList, setNegociosList] = useState<any[]>([])
  const [organizationByUser, setOrganizationByUser] = useState<any[]>([])
  const [payMethodsList, setPayMethods] = useState<any[]>([])
  const [promoterByEds, setPromotersByEds] = useState<any[]>([])
  const [sicomStates, setSicomStates] = useState<any[]>([])
  const [loyaltyProgramOptions, setLoyaltyProgramOptions] = useState<any[]>([])
  const [productoList, setProductoList] = useState<any[]>([])

  const getOrganizationByUser = async () => {
    const data: any = await getOrganizationsByUser(usuario.p_id)
    setOrganizationByUser(parseToSelectOption(data.organizaciones, 'descripcion', 'id'))
  }


  const getMediosPagosService = async () => {
    const response = await getMediosPagos('14')
    const transformedOptions = parseToSelectOption(response.filter((it: any) => it.estado == 'A'), 'descripcion', 'descripcion')
    
    // Eliminar duplicados basándose en el value único
    const uniqueOptionsMap = new Map<string, any>()
    transformedOptions.forEach((option: any) => {
      if (!uniqueOptionsMap.has(option.value)) {
        uniqueOptionsMap.set(option.value, option)
      }
    })
    
    setPayMethods(Array.from(uniqueOptionsMap.values()))
  }

  const getPromoter = async (empresaId: number) => {
    const response = await getSelectPromotores(empresaId)
    setPromotersByEds(parseToSelectOption(response, 'nombre', 'nombre').sort((a, b) => a?.label.localeCompare(b?.label)))
  }

  const resetPromoter = () => setPromotersByEds([])


  
  const obtenerDatosEDS = async () => {
    const estacionesbd = await getSelectEDS(empresasHijos)
    setedsList(estacionesbd)
  }
  const obtenerDatosNegocios = async () => {
    const businessLis = await getBusinessService()
    setNegociosList(parseToSelectOption(businessLis, 'descripcion', 'id_tipo_negocio'))
  }


  const obtenerEstadosSicom = async () => {
    const response = await getSicomStates()
    setSicomStates(parseToSelectOption(response?.data?.states, 'nombre', 'id'))
  }

  const obtenerDatosProductos = async () => {
    const productos = await getSelectProductos('12')
    setProductoList(parseToSelectOption(productos, 'descripcion', 'id'))
  }

  const getProgramLoyalty = async () => {
    try {
      const data = await getProgramasLoyalty()
      setLoyaltyProgramOptions(data)
    } catch (error) {

    }
  }
  const isAdmin = useMemo(() => usuario.tipo == 5, [usuario])
  useEffect(() => {
    if (eds) {
      obtenerDatosEDS()
    }
    if (business) {
      obtenerDatosNegocios()
    }

    if (organizations) {
      getOrganizationByUser()
    }

    if (payMethods) {
      getMediosPagosService()
    }
    if (stateSicom) {
      obtenerEstadosSicom()
    }
    if (fidelization_program) {
      getProgramLoyalty()
    }
    if(producto){
      obtenerDatosProductos()
    }

  }, [])


  return (
    {
      edsList,
      sicomStates,
      negociosList,
      isAdmin,
      organizationByUser,
      empresasHijos,
      payMethodsList,
      getPromoter,
      promoterByEds,
      resetPromoter,
      empresa_id: usuario?.empresas_id,
      usuario,
      loyaltyProgramOptions,
      productoList
    }
  )
}

export default useGenericInfo